<template lang="pug">
div
  div(style="text-align:center")
    button.button.is-dark.is-static {{start.format("MMM DD")}} - {{end.format("MMM DD, YYYY")}}
  div(style="text-align:center;padding:0.5rem")
    button.button.is-info(@click="minus").margin-right &lt;&lt;
    button.button.is-info(@click="plus") &gt;&gt;

</template>

<script>
import { mapState } from "vuex";
import moment from "moment";

export default {
  name: "WeekPicker",

  computed: {
    start: {
      get() {
        const f = moment(this.$store.state.sunday);
        return f;
      }
    },
    end: {
      get() {
        const f = moment(this.$store.state.sunday);
        f.add(1, "week");
        return f;
      }
    }
  },
  methods: {
    plus() {
      this.$store.commit("week_plus");
    },
    minus() {
      this.$store.commit("week_minus");
    }
  }
};
</script>

<style scoped lang="less">
label {
  color: white;
}
</style>